import TeaserBox from './TeaserBox'

export default TeaserBox